import { useState } from "react";

import { Grid, Button, Typography } from "@mui/material";

import { SearchActionInput, TextField } from "@aclymatepackages/atoms";

const CompanyDescriptionNameSearch = ({
  onCompanyNameSearch,
  typographyProps = {},
}) => {
  const [searchName, setSearchName] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [companyDescription, setCompanyDescription] = useState("");

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography
          variant="h3"
          color="textPrimary"
          align="center"
          {...typographyProps}
        >
          Let&apos;s see if we can find your company
        </Typography>
      </Grid>
      <Grid item>
        <TextField
          label="What does your company do?"
          value={companyDescription}
          setValue={setCompanyDescription}
        />
      </Grid>
      <Grid item>
        <SearchActionInput
          label="What is your company's name?"
          value={searchName}
          setValue={setSearchName}
          searchLoading={searchLoading}
          searchFunction={onCompanyNameSearch}
          helperText="Put in your full company's name (e.g. United Airlines instead of United). We'll use AI to look up information about your company."
        />
      </Grid>
      <Grid item container justifyContent="center">
        <Grid item>
          <Button
            variant="contained"
            onClick={() => {
              setSearchLoading(true);
              return onCompanyNameSearch(searchName, companyDescription);
            }}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default CompanyDescriptionNameSearch;
